import React from 'react';
import './App.css';
import Container from '@material-ui/core/Container';
import Navigation from './components/navigation';
import { makeStyles } from '@material-ui/core/styles';
import Copyright from './components/copyright'
import Contact from './components/contact'
import { BrowserRouter as Router, Route, Switch, Redirect, useLocation } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline';
import Home from './pages/home';

const NewsPaper = React.lazy(() => import('./pages/newspaper'));
const NewsDetail = React.lazy(() => import('./pages/newsdetail'));
const About = React.lazy(() => import('./pages/about'));
const Product = React.lazy(() => import('./pages/product'));
const ContactPage = React.lazy(() => import('./pages/contactpage'));
const ContactAnalytics = React.lazy(() => import('./pages/contactanalytics'));
const Iso9001 = React.lazy(() => import('./pages/iso9001'));
const Sni = React.lazy(() => import('./pages/sni'));
const Tkdn = React.lazy(() => import('./pages/tkdn'));

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    }
  },
}));

function App(): JSX.Element {
  const classes = useStyles();
  const Footer = (): JSX.Element => {
    const location = useLocation();
    const hideFooterContact = location.pathname.startsWith('/contact');
    return (
      <Container maxWidth="xl" component="footer" className={classes.footer}>
        {!hideFooterContact && <Contact />}
        <Copyright />
      </Container>
    );
  };
  return (
    <>
      <CssBaseline />
      <div className="app-shell">
        <Container maxWidth="xl" disableGutters={true}>
          <Router>
            <Navigation />
            <React.Suspense fallback={<div className="route-loading" role="status" aria-live="polite">Memuat halaman...</div>}>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/home">
                  <Redirect to="/" />
                </Route>
                <Route path="/products/page/:pageNumber" component={Product} />
                <Route path="/news/page/:pageNumber" component={NewsPaper} />
                <Route path="/news/detail/:newsTitle" component={NewsDetail} />
                <Route path="/about" component={About} />
                <Route path="/iso-9001" component={Iso9001} />
                <Route path="/sni" component={Sni} />
                <Route path="/tkdn" component={Tkdn} />
                <Route path="/contact-analytics" component={ContactAnalytics} />
                <Route path="/contact" component={ContactPage} />
                <Redirect to="/" />
              </Switch>
              <Footer />
            </React.Suspense>
          </Router>
        </Container>
      </div>
    </>
  );
}

export default App;
